@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@border-radius: 5px;
@border-color: @orders-drawer--default--options--border-color;

.item-list-wrapper {
  padding: 10px 15px;
}

.item-list-header {
  text-align: center;
  font-size: 14px;
  color: @orders-drawer--order-items--text-color;
  background-color: @orders-drawer--order-items--background-color;
  padding: 10px 5px 5px;
}

.item-list-title {
  text-align: left;
  display: flex;
  white-space: nowrap;
  overflow: hidden;

  .item-list-title-label {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.item-list {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-row-gap: 1px;
  background-color: @orders-drawer--order-items-list--background-color;
  padding-bottom: 1px;

  .third-party-logo {
    height: 12px;
    margin-right: 4px;
    width: 12px;
  }
}

.without-inventory {
  grid-template-columns: 1fr auto;
}

.no-items {
  font-style: italic;
  width: 100%;
  color: @orders-drawer--order-items--no-items--text-color;
  background-color: @orders-drawer--order-items--background-color;
  text-align: center;
  font-size: 14px;
  padding: 10px 0;
}

.section-header-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.group-by-selector {
  color: @orders-drawer--order-items--fill-color;
  cursor: pointer;
  padding-top: 4px;

  &:hover {
    color: @orders-drawer--default--hover--fill-color;
  }

  &:focus {
    color: @orders-drawer--default--hover--fill-color;
  }
}

.group-by-selector-dropdown {
  margin-right: -10px;
}

.group-items-by-toggler {
  height: 18px;
  width: 18px;
}

.options-content {
  border-radius: 5px;
  background-color: @orders-drawer--order-items--background-color;
  overflow: hidden;
  width: 150px;

  .options-title {
    padding: 5px;
    background-color: @orders-drawer--order-items-title--background-color;
    border: 1px solid @border-color;
    border-top-right-radius: @border-radius;
    border-top-left-radius: @border-radius;
    font-size: 13px;
  }

  .options {
    border-bottom-right-radius: @border-radius;
    border-bottom-left-radius: @border-radius;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: @border-color;
    overflow: hidden;

    * {
      cursor: pointer;
    }

    .option {
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 5px;

      > label {
        padding-left: 5px;
      }

      &:hover {
        background-color: @orders-drawer--order-items-options--hover--background-color;
      }
    }
  }
}

.inventory-grid {
  grid-template-columns: 1fr auto auto;
}

.non-inventory-grid {
  grid-template-columns: 1fr auto;
}
